var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",class:{ 'logo-mobile': _vm.isMobile },on:{"click":function($event){return _vm.$router.push('/home-page-tile')}}})}
var staticRenderFns = []

export { render, staticRenderFns }